import { render } from "./StatePensionHelp.vue?vue&type=template&id=220b706c&scoped=true&ts=true"
import script from "./StatePensionHelp.vue?vue&type=script&lang=ts"
export * from "./StatePensionHelp.vue?vue&type=script&lang=ts"

import "./StatePensionHelp.vue?vue&type=style&index=0&id=220b706c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220b706c"]])

export default __exports__